import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Receipt } from "../models/receipt";
import { ConfigService } from "./config.service";

@Injectable({
  providedIn: "root",
})
export class ReceiptService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);

  getReceipt(transactionGuid: string): Observable<Receipt> {
    const url = `${this.configService.getApiUrl()}/receipt/${transactionGuid}`;
    return this.http.get(url).pipe(map((response) => response as Receipt));
  }
}
